<div *ngIf="mailContents" class="full-grow-no-shrink-no-basis" style="overflow: auto;" class="flex flex-col">
  <div *ngFor="let item of emailThread.emails; let i = index"
       class="mail-template-content-container flex flex-row full-grow-no-shrink-no-basis">
    <div class="w-p-100">
      <!--            <particle-mail-thread-single-content [item]="item"></particle-mail-thread-single-content>-->
      <app-single-email-container [email]="item" [labels]="emailThread.labels"></app-single-email-container>

      <particle-reply-message (discardMessage)="discardMsg($event)"
                              *ngIf="i === (mailContents.length-1) && !mailThread.noReply"
                              [mailContent]='item'></particle-reply-message>
      <!--      <app-email-thread-container></app-email-thread-container>-->
    </div>
  </div>
</div>

<!--*ngIf="item.isLastMail && !mailThread.noReply"-->
